<template>
	<section v-if="props">
		<carousel :navigationEnabled="true" :navigationNextLabel="''" :navigationPrevLabel="''" :perPage="1" :paginationActiveColor="'#f58466'" :paginationColor="'#999999'" :navigationClickTargetSize="5" :paginationPadding="5" :paginationSize="14" v-in-viewport="{}">

			<template class="image-slider" v-if="props.length" v-for="(slide,i) in props">
				<slide class="column-slider">
					<div class="row">
						<div class="inside">

							<div class="info">
								<h3>{{slide.headline.value}}</h3>
								 <div v-html="slide.content.value">
									</div>

									<button class="button-custom prev" :data-next="i" @click="goToPrev(i)" :class="{disabled : i == 0 }" ></button>
									<button class="button-custom next" :data-next="i" @click="goToNext(i)" :class="{disabled : i == props.length - 1 }" ></button>

							</div>

							<template v-if="slide.vimeo_id">
								<div   class="video-container" v-if="slide.vimeo_id.value != ''">
									<div class="embed-container">
										<iframe :src="'https://player.vimeo.com/video/'+slide.vimeo_id.value+'?loop=1&title=0&byline=0&portrait=0&api=1'" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
									</div>
								</div>
								
								<div class="image" v-else>
									<img :src="slide.image.value[0].url" :alt="slide.headline.value" />
								</div>
							</template>		
						</div>
					</div>
				</slide>
			</template>
		</carousel>
	</section>
</template>


<script>
  require('../assets/img/left.svg');
	require('../assets/img/right.svg');
	require('../assets/img/left_hover.svg');
	require('../assets/img/right_hover.svg');




	import { Carousel, Slide } from 'vue-carousel';
	import commons from '../mixins/common.js';
	import Player from '@vimeo/player';

	export default{
		name:'Slider',
		props: ['props'],
		mixins:[commons],
		components:{
			Carousel,
			Slide
		},
		data(){
			return{

			}
		},
		methods: {

			handleSlideClick: function(dataset) {
				setTimeout(function(){
					let v = dataset.videoid;
					$('.play-button[data-video-id='+dataset.name+']').hide();
					const player = new Player(document.getElementById(v), {
				    id: dataset.name,
				    width: 640,
						autoplay: true
					});

				},200);
			},
			goToNext: function(index){
				var el = document.getElementsByClassName("VueCarousel-navigation-next");
				var point = document.getElementsByClassName("VueCarousel-slide");

				for (var i=0; index<point.length;  i++) {
						// if(i == index){
						// 	el[i].click();
						// }
						el[i].click();
						
						
				}
			},
			goToPrev: function(index){
				var el = document.getElementsByClassName("VueCarousel-navigation-prev");
				var point = document.getElementsByClassName("VueCarousel-slide");
				for (var i=0; index<point.length; i++) {
						// if(i == index -1){
						// 	el[i].click();
						// }
						el[i].click();
				
				}
			},
		},

		mounted () {
			setTimeout(function(){

					$('.VueCarousel-dot-button,.VueCarousel-navigation-button').on('click', function(){
						$('iframe').each(function() {
						  this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
						  this.contentWindow.postMessage('{"method":"pause","value":""}', '*');
						});
					})

			},200);

		}
	}
</script>



// WEBPACK FOOTER //
// slider-video.vue?80e001f2